import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ModelListWithCursor} from '../../../commons/angular/models/model-list-with-cursor.model';
import {PublishedTermsResponse, TermsPayload, TermsStatus, TermsVersion} from '../models/terms-version.model';

@Injectable({providedIn: 'root'})
export class TermsHttpService {
  private base_url = '/terms';

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  // The cursor carries the page size and ordering, so `limit` only matters on the first page.
  // Every list item is the full version, content included - no per-row content fetch is needed.
  getList(params: { limit?: number; cursor?: string }): Observable<ModelListWithCursor<TermsVersion>> {
    return this.http.get<ModelListWithCursor<TermsVersion>>(this.base_url, {params});
  }

  create(payload: TermsPayload): Observable<TermsVersion> {
    return this.http.put<TermsVersion>(this.base_url, payload);
  }

  update(id: string, payload: TermsPayload): Observable<TermsVersion> {
    return this.http.post<TermsVersion>(`${this.base_url}/${id}`, payload);
  }

  setStatus(id: string, status: TermsStatus): Observable<TermsVersion> {
    return this.http.post<TermsVersion>(`${this.base_url}/${id}/status/${status}`, null);
  }

  getPublished(): Observable<PublishedTermsResponse> {
    return this.http.get<PublishedTermsResponse>(`${this.base_url}/published`);
  }
}
